module.exports = __webpack_public_path__ + "static/media/avatar-15.9eae6398.svg";